/**
 * Check if any modal/popup is open (login, signup, import, feedback, etc.).
 * Used to avoid auto-focusing task/placeholder when the user is interacting with a popup.
 * @returns {boolean}
 */
export function isPopupOpen() {
  if (typeof document === 'undefined') return false;
  return (
    document.querySelector('.signup-login-modal-backdrop') !== null ||
    document.querySelector('.import-info-modal-backdrop') !== null ||
    document.querySelector('.feedback-modal-backdrop') !== null
  );
}
